import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
const TermsAndConditions = () => {
  return <>
      <Helmet>
        <title>Terms and Conditions | Wamy AI</title>
        <meta name="description" content="Terms and conditions for using Wamy AI services." />
      </Helmet>

      <Navbar />
      
      <main className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        
        
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
          <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=bcdb8ffe-b637-4f21-a3b1-d4aade74b777" title="Terms and Conditions" className="w-full h-[800px] border-0" frameBorder="0" />
        </div>
      </main>
      
      <Footer />
    </>;
};
export default TermsAndConditions;